import {combineReducers} from "redux";
import pontosVendaReducer from './PontosVenda';

const RootReducer = combineReducers({
  pontosVenda: pontosVendaReducer
});

export default RootReducer
